import Class from '@/Class';
import type SummaryView from '@/SummaryViews/SummaryView';

export default class SummaryViewTuple extends Class {
    public summaryView: JQuery;

    constructor(summaryView: SummaryView, $view: JQuery) {
        super();
        this.summaryView = $view;
        this.isDisposable = true;
    }
}